import request from "@/utils/request";

export default function agentGetAccessControlDeviceNumDateil() {
  return request.get(
    `/device/accessControllerDevice/agentGetAccessControlDeviceNumDateil`
  );
}
